var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.622
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-menu",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 34",
    d: "M15.333 1.946H.667C.3 1.946 0 1.508 0 .973 0 .438.3 0 .667 0h14.666C15.7 0 16 .438 16 .973c0 .535-.3.973-.667.973z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35",
    d: "M15.333 7.784H.667C.3 7.784 0 7.346 0 6.811c0-.535.3-.973.667-.973h14.666c.367 0 .667.438.667.973 0 .535-.3.973-.667.973z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "M15.333 13.622H.667c-.367 0-.667-.438-.667-.973 0-.535.3-.973.667-.973h14.666c.367 0 .667.438.667.973 0 .535-.3.973-.667.973z"
  }))));
}
export default SvgMenuIcon;